import CompanyMergeModal from "@/desktop/components/CompanyMergeModal";
import SearchClientModal from "@/desktop/components/SearchClientModal";
import MvInfo from "@/desktop/views/mv/components/mvInfo";
import { commonMixin as GolbalCommonMixins } from "@/mixins/common";
import {
  createOtherLifeInsurance,
  getAnnual,
  getCompanies,
  getInsuranceTypes,
  getPlan,
  queryOtherLifeInsurance,
  updateOtherLifeInsurance,
  getRelationsByPolicyID,
} from "@/service";
import moment from "moment";
import CommonMixins, { DIFF_BETWEEN_ROC_AND_YEARS, padLeft } from "./common";
import Bnf from "./components/bnf";
import GoOnAddOtherCompContract from "./bkGoOnAddOtherCompContract";
import TruncateTool from "./components/TruncateTool";

const { _ } = window;
const padLeft2_0 = padLeft(2, "0");

const INIT_BNFs = [
  {
    nm: "",
    other: "",
  },
];
const INIT_DATA = {
  companyid: "",
  productid: "",
  apc: "",
  csidno: "",
  plcno: "",
  prd: "",
  pay_freq: "",
  policyid: "",
  famt: "",
  sche: "",
  year: moment().getROCDate("YYYY"),
  month: moment().format("MM"),
  day: moment().format("DD"),
  year2: "",
  month2: "",
  day2: "",
  csidno2: [
    {
      csidno: "",
      relatedtoprimaryinsured: "",
    },
  ],
  bnf_death: _.cloneDeep(INIT_BNFs),
  bnf_matag: _.cloneDeep(INIT_BNFs),
  bnf_annuity: _.cloneDeep(INIT_BNFs),
  bnf_birth: _.cloneDeep(INIT_BNFs),
  sche_nm: "",
  sche_amt: "",
};

const convertToBackend = {
  relationship: {
    0: 2,
    1: 1,
    2: 0,
    3: 3,
  },
};
const convertToFrentend = {
  relationship: _.invert(convertToBackend.relationship),
};

export default {
  mixins: [CommonMixins, GolbalCommonMixins],
  components: {
    CompanyMergeModal,
    SearchClientModal,
    MvInfo,
    GoOnAddOtherCompContract,
    Bnf,
    TruncateTool,
  },
  data: () => ({
    options: {
      companies: [],
      insuranceTypes: [],
      annual: [],
      plan: [],
      relationship: {
        1: "配偶",
        2: "子女",
      },
      paymentWayList: {
        1: "月繳",
        2: "季繳",
        3: "半年繳",
        4: "年繳",
        5: "躉繳",
        6: "彈性繳",
      },
      customApcFamilies: [],
      customCsidnoFamilies: [],
      customCsidno2Families: [],
      prds: [],
      inRequest: false,
    },
    translate: {
      unit: {
        1: "元",
        2: "萬",
        3: "單位",
      },
      currencytype: {
        1: "TWD",
        2: "USD",
        3: "AUD",
        4: "GBP",
        5: "EUR",
        6: "NZD",
        7: "HKD",
        8: "JPY",
        9: "CNY",
        10: "ZAR",
      },
      currencytypeTW: {
        1: "元",
        2: "美元",
        3: "澳幣",
        4: "英鎊",
        5: "歐元",
        6: "紐幣",
        7: "港幣",
        8: "日幣",
        9: "人民幣",
        10: "南非幣",
      },
    },
    editData: _.cloneDeep(INIT_DATA),
    mergeModalOpen: false,
    clientSearchOpen: false,
    clientSearchSubmitMethod: "",
    clientSearchIndex: "",
    mvInfoOpen: false,
    goOnAddOtherCompContractOpen: false,
    bnf_death: null,
    bnf_matag: null,
    bnf_annuity: null,
    bnf_birth: null,
    contract_id: "",
    reload: 0,
    allRelations: [],
    isLoading: false,
  }),
  watch: {
    myValidation: {
      deep: true,
      handler(newVal, oldVal) {
        _.forEach(newVal, ({ watch, result, message }, key) => {
          watch &&
            !result &&
            oldVal[key].result != result &&
            this.$toast.info({ title: message });
        });
      },
    },
  },
  methods: {
    reset() {
      this.editData = _.cloneDeep(INIT_DATA);
      this.options.insuranceTypes = [];
      this.options.annual = [];
      this.options.plan = [];
      this.reload++;
    },
    async getOptions() {
      this.getFamilyOption();
      this.getCompaniesOption();
    },
    async getCompaniesOption() {
      const res = await getCompanies(this.user_id);
      this.options.companies = res.body;
    },
    async getInsuranceTypes(companyid, ref_id) {
      // 1 master // 2 sub
      if (!companyid) {
        this.options.insuranceTypes = [];
      } else {
        this.options.insuranceTypes = [];
        this.$nextTick(() =>
          this.getInsuranceTypesDirect(companyid).then(this.onInsuranceChange)
        );
      }
      this.editData.productid = "";
      if (this.$refs[ref_id]) {
        this.$refs[ref_id].clearSelection();
      }
    },
    async getInsuranceTypesDirect(companyid) {
      this.options.inRequest = true;
      const res = await getInsuranceTypes(
        this.user_id,
        companyid,
        this.contract_type
      );
      this.options.insuranceTypes = res.body.filter((e) => {
        // 暫時處理
        return e.PRODUCTID == "bc2a86ff343c456fb76043000c519786" ? false : true;
      });
      this.options.inRequest = false;
    },
    onInsuranceChange() {
      this.getAnnual(this.currentInsuranceType.PRODUCTID);
      this.usePlan && this.getPlan(this.currentInsuranceType.PRODUCTID);
    },
    async getAnnual(productid) {
      const res = await getAnnual(this.user_id, productid);
      this.options.annual = res.body.TERMINABLEPERIODS
        ? res.body.TERMINABLEPERIODS.split(",")
            .filter((x) => x)
            .map((x) => ({
              value: padLeft2_0(x),
              name: padLeft2_0(x),
            }))
            .concat(
              res.body.AGEPERIODS.split(",")
                .filter((x) => x)
                .map((x) => ({
                  value: padLeft2_0(x),
                  name: `${padLeft2_0(x)}@`,
                }))
            )
            .sort((a, b) => +a.value - +b.value)
        : res.body.AGEPERIODS
          ? res.body.AGEPERIODS.split(",")
              .filter((x) => x)
              .map((x) => ({
                value: padLeft2_0(x),
                name: `${padLeft2_0(x)}@`,
              }))
          : [];
    },
    async getPlan(productid) {
      const res = await getPlan(this.user_id, productid);
      this.options.plan = res.body;
    },
    async submitClient(res) {
      res = {
        csidno: res.id || res.ser_no || "",
        name: res.name,
      };
      this.clientSearchSubmitMethod(res);
      await this.panelClose("clientSearchOpen");
      window.scrollTo(0, this.scrollY);
      this.$nextTick(() => {
        this.registerHanlink();
      });
    },
    async cancelClient() {
      await this.panelClose("clientSearchOpen");
      window.scroll(0, this.scrollY);
    },
    // apc 要保人
    onApcChange(value) {
      if (value === "search") {
        this.clientSearchSubmitMethod = this.onApcClientSearchSubmit;
        this.scrollY = window.scrollY;
        this.editData.apc = "";
        this.panelOpen("clientSearchOpen");
      }
    },
    onApcClientSearchSubmit(res) {
      !this.options.customApcFamilies.find((x) => x.csidno === res.csidno) &&
        this.options.customApcFamilies.push(res);
      this.editData.apc = res;
    },
    // 主被保人
    onCsidnoChange(value) {
      if (value === "search") {
        this.clientSearchSubmitMethod = this.onCsidnoClientSearchSubmit;
        this.scrollY = window.scrollY;
        this.editData.csidno = "";
        this.panelOpen("clientSearchOpen");
      }
    },
    onCsidnoClientSearchSubmit(res) {
      !this.options.customCsidnoFamilies.find((x) => x.csidno === res.csidno) &&
        this.options.customCsidnoFamilies.push(res);
      this.editData.csidno = res.csidno;
    },
    // csidno2 次被保人
    addCsidno2(i) {
      this.editData.csidno2.splice(i + 1, 0, {
        csidno: "",
        relatedtoprimaryinsured: "",
      });
      this.registerHanlink(); // for 難字更新
    },
    onCsidno2Change(value, index) {
      const csidno2 = this.editData.csidno2[index];
      const family = this.familiesKeyByCsidno[value];
      csidno2.relatedtoprimaryinsured = "";
      csidno2.name = family ? family.name : "";
      if (value === "search") {
        this.clientSearchSubmitMethod = this.onCsidno2ClientSearchSubmit;
        this.clientSearchIndex = index;
        this.scrollY = window.scrollY;
        csidno2.csidno = "";
        this.panelOpen("clientSearchOpen");
      }
    },
    onCsidno2ClientSearchSubmit(res) {
      !this.options.customCsidno2Families.find(
        (x) => x.csidno === res.csidno
      ) && this.options.customCsidno2Families.push(res);
      this.editData.csidno2[this.clientSearchIndex].csidno = res.csidno;
    },
    async checkValidate() {
      return new Promise(async (resolve) => {
        if (
          (await this.$validator.validateAll()) &&
          _.map(this.myValidation).every(({ result }) => result)
        ) {
          resolve();
        } else {
          _.map(this.myValidation).forEach(({ result, message }) => {
            !result && this.$toast.info({ title: message });
          });
          const errorRuls = this.errors.items.map((x) => x.rule);
          if (errorRuls.some((x) => ["numeric", "decimal"].includes(x))) {
            this.$toast.info({ title: "欄位格式有錯" });
          }
          if (errorRuls.some((x) => x === "required")) {
            this.$toast.info({ title: "尚有欄位未填寫" });
          }
          this.isLoading = false;
        }
      });
    },
    checkDecimal2(value, name) {
      if (value) {
        let result = value.match(/[0-9]+(.[0-9]{0,2})?/g);
        if (result[0]) {
            this.editData[name] = result[0];
        }
      }
    },
    async fixYearTypeByPrd() {
      if (this.editData.prd) {
        let rAry = this.options.annual.filter(
          (x) => x.value === this.editData.prd
        );
        this.editData.year_type =
          rAry[0].name && rAry[0].name.includes("@") ? 2 : 1;
      }
    },
    onScheChange() {
      if (this.editData.sche) {
        this.editData.sche_nm = this.editData.sche.NAME;
        this.editData.sche_amt = this.editData.famt = this.editData.sche.QUANTITY;
      }
    },
    async doQuery() {
      const res = await queryOtherLifeInsurance({
        ..._.pick(this.$route.query, ["contract_id", "policyid"]),
        source : "BNK"
      });
      if (!this.options.families || this.options.families.length < 1) {
        //20211201 getAllFamily未回來時強制等待
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      this.options.customApcFamilies = this.options.customCsidnoFamilies = this.options.customCsidno2Families =
        res.body.costom_options;

      const rdstdt = moment(res.body.issue_date);
      const anty_pay_date = moment(res.body.anty_pay_date);
      // 主被保人
      const CSIDNO_RELATED = 2;
      const csidnoRelated = _.find(res.body.relation, {
        relatedtoprimaryinsured: CSIDNO_RELATED,
      });
      const csidno2Related = _.filter(
        res.body.relation,
        (x) => x.relatedtoprimaryinsured != CSIDNO_RELATED
      ).map((x) => ({
        ...x,
        relatedtoprimaryinsured:
          convertToFrentend.relationship[x.relatedtoprimaryinsured],
      }));
      const familiesNames = _.map(this.options.families, "name");

      Object.assign(
        this.editData,
        _.pick(res.body, [
          "productid",
          "contract_id",
          "policyid",
          "famt",
          "prem",
          "sche_nm",
          "sche_amt",
          "plcvl",
          "unit_no",
          "min_guaran_die",
          "min_guaran_due",
          "pay_freq",
        ]),
        _.pick(res.body.policy, ["plcno", "agidno"]),
        {
          companyid: this.$route.query.companyid,
          year: rdstdt.getROCDate("YYYY"),
          month: rdstdt.format("MM"),
          day: rdstdt.format("DD"),
          prd: padLeft2_0(res.body.prd),
          apc: res.body.policy.apcid
            ? {
                csidno: res.body.policy.apcid,
                name: _.find(this.options.families, {
                  csidno: res.body.policy.apcid,
                }).name,
              }
            : "",
          csidno: _.get(csidnoRelated, "csidno"),
          csidno2: csidno2Related.length
            ? _.orderBy(csidno2Related, "relatedtoprimaryinsured")
            : [
                {
                  csidno: "",
                  relatedtoprimaryinsured: "",
                },
              ],
          // 受益人物件
          ...["bnf_death", "bnf_matag", "bnf_annuity", "bnf_birth"].reduce(
            (result, prop) => {
              //20210426 判斷無key塞上去
              if (!res.body[prop + "_nm"]) {
                res.body[prop + "_nm"] = "";
              }
              result[prop] = res.body[prop + "_nm"].split(",").map((x) => {
                const inFamily = familiesNames.includes(x);
                const nm = x
                  ? inFamily
                    ? x
                    : x == "法定繼承人"
                      ? x
                      : "other"
                  : "";
                const other = x ? (inFamily ? "" : x) : "";
                return { nm, other };
              });
              return result;
            },
            {}
          ),
        },
        {
          sche: {
            NAME: res.body.sche_nm,
            QUANTITY: res.body.sche_amt,
          },
        },
        res.body.anty_pay_date
          ? {
              year2: anty_pay_date.getROCDate("YYYY"),
              month2: padLeft2_0(anty_pay_date.month() + 1),
              day2: padLeft2_0(anty_pay_date.date()),
            }
          : {}
      );
      this.getInsuranceTypesDirect(this.editData.companyid).then(
        this.onInsuranceChange
      );

      this.$nextTick(() => {
        this.registerHanlink();
      });
    },
    async doCreate() {
      this.isLoading = true;
      this.doRequest(createOtherLifeInsurance, "新增");
    },
    async doUpdate() {
      this.isLoading = true;
      this.doRequest(updateOtherLifeInsurance, "更新");
    },
    async doRequest(fn, action) {
      await this.fixYearTypeByPrd();
      await this.checkValidate();
      const res = await fn(this.requestBody);
      this.isLoading = false;
      if (res.header && res.header.status === "200") {
        this.editData.policyid = res.body.policyid;
        this.contract_id = res.body.contract_id;
        this.$toast.info({ title: `${action}成功` });
        if (!this.isCsidnoSomeInFamilies && !this.isAllContractSomeInFamilies) {
          this.panelOpen("mvInfoOpen");
        } else {
          this.isUpdate
            ? this.toPolicyEditList({ modify: this.modifyContractIDs })
            : this.panelOpen("goOnAddOtherCompContractOpen");
        }
      } else {
        if (res.header && res.header.message) {
          this.$toast.info({ title: res.header.message });
        } else {
          this.$toast.info({ title: `${action}失敗` });
        }
      }
    },
    cancelAdd() {
      this.$toast.info({ title: this.isUpdate ? "取消修改" : "取消新增" });
      this.toPolicyEditList({
        modify: this.modifyContractIDs,
      });
    },
    isCsidnoNotInOptions(csidno, options) {
      return (
        csidno &&
        !_.find(options, {
          csidno,
        })
      );
    },
    getPersonName(options, value) {
      return value
        ? _.get(
            _.find(options, {
              csidno: value,
            }),
            "name",
            ""
          )
        : "";
    },
    async checkRelationsByPolicyID() {
      const res = await getRelationsByPolicyID({
        policyid: this.$route.query.policyid,
      });
      this.allRelations = res.body;
    },
  },
  computed: {
    usePlan() {
      return this.currentInsuranceType.UNIT === 0;
    },
    currentInsuranceType() {
      const listKeyByID = _.keyBy(this.options.insuranceTypes, "PRODUCTID");
      return listKeyByID[this.editData.productid] || {};
    },
    isProductType3() {
      return this.currentInsuranceType.PRODUCTTYPE === 3;
    },
    isAntyPayDateError() {
      const ALL_KEY = [
        this.editData.year2,
        this.editData.month2,
        this.editData.day2,
      ];
      return (
        (this.isProductType3 && !this.anty_pay_date) ||
        (ALL_KEY.some((x) => x) && ALL_KEY.some((x) => !x))
      );
    },
    optionPaymentWayList() {
      const listString = this.currentInsuranceType
        ? this.currentInsuranceType.PAYMENTWAYLIST
        : "";
      return listString
        ? _.pick(this.options.paymentWayList, listString.split(","))
        : this.options.paymentWayList;
    },
    anty_pay_date() {
      return this.editData.year2 && this.editData.month2 && this.editData.day2
        ? [
            +this.editData.year2 + DIFF_BETWEEN_ROC_AND_YEARS,
            this.editData.month2,
            this.editData.day2,
          ].join("-")
        : "";
    },
    isBnfDeathInValid() {
      return this.bnf_death && this.bnf_death.hasInValid();
    },
    isBnfMatagInValid() {
      return this.bnf_matag && this.bnf_matag.hasInValid();
    },
    isBnfAnniuityInValid() {
      return this.bnf_annuity && this.bnf_annuity.hasInValid();
    },
    isBnfBirthInValid() {
      return this.bnf_birth && this.bnf_birth.hasInValid();
    },
    isCsidnoSameWithCsidno2() {
      return (
        this.editData.csidno &&
        this.editData.csidno2
          .map((x) => x.csidno)
          .includes(this.editData.csidno)
      );
    },
    isCsidno2Repeat() {
      const filters = this.editData.csidno2
        .map((x) => x.csidno)
        .filter((x) => x);
      return filters.length != _.uniq(filters).length;
    },
    myValidation() {
      return {
        isAntyPayDateError: {
          result: !this.isAntyPayDateError,
          message: "請確實選擇年金給付日",
        },
        isRdstdtError: {
          result: !this.isRdstdtError,
          message: "投保日期不得超過今日",
        },
        isCsidnoSameWithCsidno2: {
          watch: true,
          result: !this.isCsidnoSameWithCsidno2,
          message: "主被保人與次被保人不得為同一人",
        },
        isCsidno2Repeat: {
          watch: true,
          result: !this.isCsidno2Repeat,
          message: "次被保人不得重複",
        },
        isFamtError: {
          watch: true,
          result: !(
            this.currentInsuranceType.UNIT == 2 &&
            this.editData.famt &&
            (this.editData.famt.toString().split(".")[0].length > 4 ||
              (this.editData.famt.toString().split(".")[1] &&
                this.editData.famt.toString().split(".")[1].length > 6))
          ),
          message: "保額請輸入數字(0萬~9999萬)",
        },
        isBnfDeathInValid: {
          result: !this.isBnfDeathInValid,
          message: "身故受益人不得重複",
        },
        isBnfMatagInValid: {
          result: !this.isBnfMatagInValid,
          message: "滿期受益人不得重複",
        },
        isBnfAnniuityInValid: {
          result: !this.isBnfAnniuityInValid,
          message: "年金受益人不得重複",
        },
        isBnfBirthInValid: {
          result: !this.isBnfBirthInValid,
          message: "祝壽金受益人不得重複",
        },
      };
    },
    familiesKeyByCsidno() {
      return this.options.families
        ? _.keyBy(this.options.families, "csidno")
        : {};
    },
    isCsidnoNotInFamilies() {
      return this.isCsidnoNotInOptions(
        this.editData.csidno,
        this.options.families
      );
    },
    isApcNotInFamilies() {
      return (
        this.editData.apc &&
        this.isCsidnoNotInOptions(
          this.editData.apc.csidno,
          this.options.families
        )
      );
    },
    csidnoName() {
      return (
        this.getPersonName(
          this.options.customCsidnoFamilies,
          this.editData.csidno
        ) || this.getPersonName(this.options.families, this.editData.csidno)
      );
    },
    apcName() {
      return this.editData.apc
        ? this.getPersonName(
            this.options.customApcFamilies,
            this.editData.apc.csidno
          )
        : "";
    },
    currencytype() {
      return this.translate.currencytype[
        this.currentInsuranceType.CURRENCYTYPE
      ];
    },
    showCurrencyType() {
      return (
        this.currentInsuranceType.CURRENCYTYPE &&
        this.currentInsuranceType.CURRENCYTYPE !== 1
      );
    },
    requestBody() {
      const getBnfValues = (bnf) => (bnf ? bnf.getValues().join(",") : "");
      return {
        ...this.editData,
        issue_date: this.rdstdt,
        anty_pay_date: this.anty_pay_date,
        agidno: this.user_id,
        contract_type: this.contract_type,
        apcid: this.editData.apc.csidno,
        apcnm: this.editData.apc.name,
        currencytype: this.currencytype,
        unit: this.currentInsuranceType.UNIT,
        familyid: this.familyData.csidno,
        csidno2: this.editData.csidno2.filter((x) => x.csidno).map((x) => ({
          ...x,
          relatedtoprimaryinsured:
            convertToBackend.relationship[x.relatedtoprimaryinsured],
        })),
        bnf_death_nm: getBnfValues(this.bnf_death),
        bnf_matag_nm: getBnfValues(this.bnf_matag),
        bnf_annuity_nm: getBnfValues(this.bnf_annuity),
        bnf_birth_nm: getBnfValues(this.bnf_birth),
        source: "BNK",
      };
    },
    familiesCsidno() {
      return this.options.families.map((x) => x.csidno);
    },
    isCsidnoSomeInFamilies() {
      return this.editData.csidno2
        .map((x) => x.csidno)
        .concat(this.editData.csidno)
        .filter((x) => x)
        .some((csidno) => this.familiesCsidno.includes(csidno));
    },
    isAllContractSomeInFamilies() {
      return this.allRelations
        .map((x) => x.CSIDNO)
        .some((csidno) => this.familiesCsidno.includes(csidno));
    },
    isUpdate() {
      return !!this.$route.query.contract_id;
    },
    isCreate() {
      return !this.$route.query.contract_id;
    },
    modifyContractIDs() {
      return [this.$route.query.modify, this.contract_id]
        .filter((x) => x)
        .join(",");
    },
    familyData() {
      if (!localStorage.userItems) {
        return {
          sex: "1",
          name: "--",
          csidno: "--",
          age: "0",
        };
      } else {
        return JSON.parse(localStorage.userItems);
      }
    },
  },
  mounted() {
    this.isUpdate && this.doQuery();
  },
};
